import { render, staticRenderFns } from "./Lifestyle2.vue?vue&type=template&id=f011df9a"
import script from "./Lifestyle2.vue?vue&type=script&lang=js"
export * from "./Lifestyle2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports